import styled from 'styled-components';

const Tags = ({ data }: any) => {
  function processItem(item: any) {
    if (!item.bidno) {
      // bidno가 없는 경우
      const match = String(item.bid).match(/\d+/); // bid를 문자열로 변환 후 숫자 추출
      if (match) {
        item.bidno = match[0]; // 숫자를 bidno로 추가
      }
    }
    return item;
  }
  const item = processItem(data);
  const MAX_VISIBLE_TAGS = 2;
  const tags =
    (item.viewgray2 &&
      item.viewgray2
        ?.trim() // 공백 제거
        .replace(/\[|\]/g, '') // 대괄호 제거
        .split(' / ') // ' / ' 기준으로 분리
        .filter((el: string) => el.trim().length > 0)) ||
    []; // 공백 제외
  return (
    <TagBox>
      {item.bidno && item.bidno > 0 && item.bidno !== null && (
        <BidTag>{'유찰' + item.bidno + '회'}</BidTag>
      )}
      {String(item.bid).trim() === '매각' && <BidTag>낙찰</BidTag>}
      {String(item.bid).trim() === '신건' && (
        <BidTag
          style={{
            color: '#1F9E54',
            backgroundColor: '#E6F4F0',
          }}
        >
          신건
        </BidTag>
      )}
      {tags.map((el: any, index: any) => (
        <>
          {el === '대항력있는 임차인' ? (
            <Tag
              key={index}
              style={{
                color: '#008AFF',
                backgroundColor: '#008AFF0F',
              }}
            >
              대항력있음
            </Tag>
          ) : (
            <Tag key={index}>{el}</Tag>
          )}
        </>
      ))}
    </TagBox>
  );
};

export default Tags;

const TagBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 8px;
  min-width: 0;
`;

const Tag = styled.div`
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  border-radius: 4px;

  color: #3e5463;
  background-color: #f2f5f7;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const BidTag = styled(Tag)`
  color: #f45551;
  background-color: #ffefef;
`;
